import React, { useState } from 'react';
import Td from '@visa/vds/td';
import Tr from '@visa/vds/tr';
import MCSPagedTable from '../../../components/MCSPagedTable';
import MCSLoading from '../../../components/MCSLoading';
import Icon from '@visa/vds/icon';
import { DateHelper } from '../../../_helpers/DateHelper';

function Announcement(props) {
    let colHeaders = [
        { displayName: "Id", name: "AnnouncementId", orderable: false },
        { displayName: "Publish Date", name: "StartDate", orderable: false },
        { displayName: "End Date", name: "EndDate", orderable: false },
        { displayName: "Announcement Display Title", name: "AnnouncementName", orderable: false },
        { displayName: "US", name: "US", orderable: false },
        { displayName: "Canada", name: "Canada", orderable: false },
        { displayName: "EU", name: "EU", orderable: false },
        { displayName: "AP", name: "AP", orderable: false },
        { displayName: "LAC", name: "LAC", orderable: false },
        { displayName: "CEMEA", name: "CEMEA", orderable: false },
        { displayName: "", name: "actions", orderable: false }
    ];

    const [selectedPage, setSelectedPage] = useState(1)

    const fetchDataOnPageChange = (page) => {
        setSelectedPage(page);
        props.fetch(page);
    }

    React.useEffect(() => {
        setSelectedPage(1)
    }, [props.changeState]);

    if (!props.fetched) {
        return (<MCSLoading />)
    }
    else {
        return (
            <>
                <MCSPagedTable size={"compact"}
                               colHeaders={colHeaders}
                               useSearchBar={false}
                               usePagination={true}
                               selectedPage={selectedPage} setSelectedPage={fetchDataOnPageChange} totalPages={props.totalPages}
                               tableData={
                                   props.data && props.data.items.map((row, key) => (
                                       <Tr key={key}>
                                           <Td>{row.id}</Td>
                                           <Td>{(row.publishState) ? DateHelper.ToLocaleDateString(row.startDate) : ''}</Td>
                                           <Td>{(row.publishState && row.endDate) ? DateHelper.ToLocaleDateString(row.endDate) : ''} </Td>
                                           <Td style={{wordBreak:"break-all"}}>{row.announcementName}</Td>
                                           <Td>{(row.us == true) ? <Icon name="checkmark" resolution="low" /> : row.us} </Td>
                                           <Td>&emsp; {(row.canada == true) ? <Icon name="checkmark" resolution="low" /> : row.canada} </Td>
                                           <Td>{(row.eu == true) ? <Icon name="checkmark" resolution="low" /> : row.eu} </Td>
                                           <Td>{(row.ap == true) ? <Icon name="checkmark" resolution="low" /> : row.ap} </Td>
                                           <Td>{(row.lac == true) ? <Icon name="checkmark" resolution="low" /> : row.lac} </Td>
                                           <Td>{(row.cemea == true) ? <Icon name="checkmark" resolution="low" /> : row.cemea} </Td>
                                           <Td><Icon onClick={() => props.setSelectedAnnouncement(row)} className="vss-clickable-icon" name="settings" resolution="low" /></Td>
                                       </Tr>
                                   ))
                               } />
            </>
        );
    }
}

export default Announcement;
